<template>
    <div>
        <dashboard-page
            v-if="navItem.type === EMenuType.DASHBOARD"
        />

        <rss-page
            v-else-if="navItem.type === EMenuType.RSS"
            :rss-link="navItem.rss"
            :order-by="navItem.orderBy"
        />

        <custom-page
            v-else-if="navItem.type === EMenuType.CUSTOM_PAGE"
            :slug="navItem.slug"
            :hidden-header="navItem.hiddenHeader"
        />

        <posts-page
            v-else-if="navItem.type === EMenuType.POSTS_PAGE"
            :post-group-ids="navItem.postGroupIds"
        />

        <menu-collection-page v-else-if="navItem.type === EMenuType.MENU_COLLECTION" />

        <event-calendar-page
            v-else-if="navItem.type = EMenuType.EVENT_CALENDAR"
            :post-group-ids="navItem.postGroupIds"
        />
    </div>
</template>

<script setup lang="ts">
    import { EMenuType } from '~/types/enums';
    import { useNavigationStore } from '~/stores/navigationStore';
    import CustomPage from '~/pages/CustomPage.vue';
    import DashboardPage from '~/pages/DashboardPage.vue';
    import MenuCollectionPage from '~/pages/MenuCollectionPage.vue';
    import RssPage from '~/pages/RssPage.vue';
    import PostsPage from '~/pages/PostsPage.vue';
    import EventCalendarPage from '~/pages/EventCalendarPage.vue';

    const navItem = useNavigationStore().getFirstNavItem;
</script>
